export default "__VITE_ASSET__DsYEctlF__"